import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';

import routes from 'app/routes';
import IconWithText from 'components/Widgets/IconWithText';
import CoachIcon from 'components/Common/Coaches/Widgets/Icon/Index';

export default function Card({ record, nextSession, refresh, children }) {
  return (
    <div className="program-card d-flex flex-column h-100">
      <header className="mb-3">
        {nextSession && (
          <span className="best-match-label me-1">
            Next Session
          </span>
        )}

        <h5 className="mt-1">
          {record.attributes.title}
        </h5>
      </header>

      <Row className="mb-2">
        <Col xs={3} className="small text-gray-700 fw-light">
          Scheduled
        </Col>

        <Col xs={9} className="small fw-semibold">
          {record.attributes.start_at_formatted || '-'}
        </Col>
      </Row>

      <Row className="mb-2">
        <Col xs={3} className="small text-gray-700 fw-light">
          Duration
        </Col>

        <Col xs={9} className="small fw-semibold">
          {record.attributes.duration}
          &nbsp;min
        </Col>
      </Row>

      <Row className="mb-2">
        <Col xs={3} className="small text-gray-700 fw-light">
          Status
        </Col>

        <Col xs={9} className="small fw-semibold">
          <IconWithText
            iconClassName="dot-icon"
            iconStyle={{
              backgroundColor: record.attributes.status.color,
              minWidth: '.8rem',
              minHeight: '.8rem',
            }}
          >
            {record.attributes.status.text}
          </IconWithText>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col xs={3} className="small text-gray-700 fw-light">
          Program
        </Col>

        <Col xs={9} className="small fw-semibold">
          {record.attributes.program
            ? (
              <a href={routes.members.programs.show(record.attributes.program.id)}>
                {record.attributes.program.title}
              </a>
            )
            : record.attributes.program.title}
        </Col>
      </Row>

      <CoachIcon
        coach={record.attributes.coach}
      />

      <div className="mt-3 text-end">
        {children}
      </div>
    </div>
  );
}

Card.propTypes = {
  record: PropTypes.object.isRequired, // step or session
  nextSession: PropTypes.bool,
  children: PropTypes.node,
};

Card.defaultProps = {
  nextSession: false,
  children: null,
};
